module.exports = __webpack_public_path__ + "media/images/covers/starworks-weekly-sept24-mobile-15ca2f448e79113d4a849ee70fa89bcf.png";